document.addEventListener('DOMContentLoaded', function () {

function lockScroll() {
  document.body.classList.add('menu-scroll-locked', 'submenu-open');
}

function unlockScroll() {
  document.body.classList.remove('menu-scroll-locked', 'submenu-open');
}



  document.body.addEventListener('click', function (e) {
    if (
  e.target.closest('.submenu-chevron-toggle') ||
  e.target.closest('.list-menu-line.expandable')
) {
  e.preventDefault();
  e.stopPropagation();

  const trigger =
    e.target.closest('.submenu-chevron-toggle') ||
    e.target.closest('.list-menu-line.expandable');

  const parentLi = trigger.closest('.list-menu--submenu');
  if (!parentLi) return;

  const button = parentLi.querySelector('.submenu-chevron-toggle');

  // Close other open menus
  document.querySelectorAll('.list-menu--submenu.is-open').forEach(function (item) {
    if (item !== parentLi) {
      item.classList.remove('is-open');
      const otherBtn = item.querySelector('.submenu-chevron-toggle');
      if (otherBtn) {
        otherBtn.setAttribute('aria-expanded', 'false');
      }
    }
  });

  const isOpen = parentLi.classList.contains('is-open');

  if (isOpen) {
    parentLi.classList.remove('is-open');
    if (button) button.setAttribute('aria-expanded', 'false');
    unlockScroll();
  } else {
    parentLi.classList.add('is-open');
    if (button) button.setAttribute('aria-expanded', 'true');
    lockScroll();
  }
}

   
    else if (e.target.closest('.submenu-close')) {
      e.preventDefault();
      e.stopPropagation();

      const closeBtn = e.target.closest('.submenu-close');
      const headerSubmenu = closeBtn.closest('.header__submenu');
      if (!headerSubmenu) return;

      const parentMenu = headerSubmenu.closest('.list-menu--submenu');
      if (!parentMenu) return;

      parentMenu.classList.remove('is-open');

      const chevronBtn = parentMenu.querySelector('.submenu-chevron-toggle');
      if (chevronBtn) {
        chevronBtn.setAttribute('aria-expanded', 'false');
      }

      
      headerSubmenu.style.opacity = '';

      
      headerSubmenu
        .querySelectorAll('.has-submenu.is-open')
        .forEach(function (item) {
          item.classList.remove('is-open');
          const toggle = item.querySelector('.submenu-toggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });

      unlockScroll();
    }

    
    else if (e.target.closest('.submenu-toggle')) {
      e.preventDefault();
      e.stopPropagation();

      const button = e.target.closest('.submenu-toggle');
      const parentLi = button.closest('.has-submenu');
      if (!parentLi) return;

      const headerSubmenu = parentLi.closest('.header__submenu');

     
      if (headerSubmenu) {
        headerSubmenu.querySelectorAll('.has-submenu.is-open').forEach(function (item) {
          if (item !== parentLi) {
            item.classList.remove('is-open');
            const toggleBtn = item.querySelector('.submenu-toggle');
            if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }

     
      const isOpen = parentLi.classList.contains('is-open');
      if (isOpen) {
        parentLi.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      } else {
        parentLi.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    }

   
    else if (!e.target.closest('.list-menu--submenu')) {
      document.querySelectorAll('.list-menu--submenu.is-open').forEach(function (item) {
        item.classList.remove('is-open');

        const btn = item.querySelector('.submenu-chevron-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');

        const submenu = item.querySelector('.header__submenu');
        if (submenu) submenu.style.opacity = '';
      });

      unlockScroll();
    }

  
    if (!document.querySelector('.list-menu--submenu.is-open')) {
      unlockScroll();
    }
  });

  
  document.querySelectorAll('.submenu-close, .submenu-toggle').forEach(function (btn) {
    const clone = btn.cloneNode(true);
    btn.parentNode.replaceChild(clone, btn);
  });

});